import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { GET_PAYMENT_LINKS_QUERY_KEY } from './useGetPaymentLinks';

export interface CreatePaymentLinkDto {
    amountCents: number;
    currency: string;
    description?: string;
}

export interface CreatePaymentLinkResponse {
    url: string;
    id: string;
}

export function useCreatePaymentLink(userId: string) {
    const queryClient = useQueryClient();
    const apiClient = useApiClient();

    return useMutation({
        mutationFn: async (dto: CreatePaymentLinkDto) => {
            const response = await apiClient.fetchApi<CreatePaymentLinkResponse, CreatePaymentLinkDto>({
                method: 'POST',
                endpoint: `payments/admin/users/${userId}/payment-links`,
                body: dto,
            });
            return response;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: GET_PAYMENT_LINKS_QUERY_KEY(userId) });
        },
    });
}
